import { useTranslation } from 'react-i18next';
import Divider from '@mui/material/Divider';
import { BaseDrawer, BaseDrawerTitle } from '@mgm/common/components/base';
import { useAppDispatch, useAppSelector } from '../../../../hooks/useAppStore';
import { getIsOpenAllSubmissionsNav } from '../../../../store/tasklists/selectors';
import { tasklistsActions } from '../../../../store/tasklists/slice';
import { SubmissionsTabs } from './SubmissionsTabs';
import { commonActions } from '../../../../store/common/slice';

const MobileSubmissionsNav = () => {
  const isOpenAllSubmissionsNav = useAppSelector(getIsOpenAllSubmissionsNav);
  const { t } = useTranslation('tasklists');
  const dispatch = useAppDispatch();

  const handleCloseNav = () => {
    dispatch(tasklistsActions.setIsOpenAllSubmissionsNav(false));
  };

  const onCloseDrawer = () => {
    dispatch(commonActions.setToggleDrawer(false));
  };

  return (
    <BaseDrawer
      drawerProps={{
        anchor: 'right',
        width: '100%',
        variant: 'persistent',
      }}
      onCloseDrawer={onCloseDrawer}
      open={isOpenAllSubmissionsNav}
    >
      <BaseDrawerTitle handleClose={handleCloseNav} title={t('allSubmissions')} />
      <Divider sx={{ borderStyle: 'dashed' }} />
      <SubmissionsTabs />
    </BaseDrawer>
  );
};

export {
  MobileSubmissionsNav,
};
